import * as types from "../types/index";
import { core } from "./core";

export const addCategory = (data) => {
  return core.API(
    "POST",
    `/non-conformities/category`,
    types.ADD_CATEGORY,
    types.ADD_CATEGORY_SUCCESS,
    types.ADD_CATEGORY_FAILURE,
    data
  );
};

export const getCategories = (queryString) => {
  return core.API(
    "GET",
    `/non-conformities/categories${queryString ? `?${queryString}` : ""}`,
    types.GET_CATEGORIES,
    types.GET_CATEGORIES_SUCCESS,
    types.GET_CATEGORIES_FAILURE
  );
};

export const getCategory = (id) => {
  return core.API(
    "GET",
    `/non-conformities/category/${id}`,
    types.GET_CATEGORY,
    types.GET_CATEGORY_SUCCESS,
    types.GET_CATEGORY_FAILURE
  );
};

export const updateCategory = (id, data) => {
  return core.API(
    "PUT",
    `/non-conformities/category/${id}`,
    types.UPDATE_CATEGORY,
    types.UPDATE_CATEGORY_SUCCESS,
    types.UPDATE_CATEGORY_FAILURE,
    data
  );
};

export const deleteCategory = (id) => {
  return core.API(
    "DELETE",
    `/non-conformities/category/${id}`,
    types.DELETE_CATEGORY,
    types.DELETE_CATEGORY_SUCCESS,
    types.DELETE_CATEGORY_FAILURE
  );
};
